// Home.js — Merge Solponiente + SectorBXII
import React, { useState, useEffect } from "react";
import logo from "../Images/regantesolponienteportada.jpeg";
import {
  Container,
  Row,
  Col,
  Nav,
  Navbar,
  Card,
  Button,
  Accordion,
} from "react-bootstrap";
import Header from "../Components/Header";
import documentosjpg from "../Images/documentos.jpg";
import registro from "../Images/registro.jpg";
import solicitudesjpg from "../Images/solicitudes.jpeg";
import notificacionesjpg from "../Images/notificaciones.jpeg";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import BuzonRegistro from "./BuzonRegistro";
import PublicacionesUsuario from "./PublicacionesUsuario";
import NotificacionesUsuario from "./NotificacionesUsuario";
import SolicitudesUsuario from "./SolicitudesUsuario";
import DocumentosPresentados from "./DocumentosPresentados";
import ExpedientesUsuario from "./ExpedientesUsuario";
import MisCertificados from "./MisCertificados";
import Footer from "../Components/Footer";
import 'bootstrap-icons/font/bootstrap-icons.css';

const Home = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [notificacionesNoLeidas, setNotificacionesNoLeidas] = useState(0);
  const [certificadosNuevos, setCertificadosNuevos] = useState(0);
  const userId = localStorage.getItem("id");

  const fetchNotificaciones = async () => {
    try {
      const response = await fetch(
        `https://oficinavirtual-solponiente.com/api/notificaciones/usuarios/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        const noLeidas = data.filter((n) => !n.Recepcion).length;
        setNotificacionesNoLeidas(noLeidas);
      }
    } catch (error) {
      console.error("Error al obtener notificaciones:", error);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchNotificaciones();
      fetchCertificadosNuevos();
    }
  }, [userId]);

  const actualizarContadorNoLeidas = () => {
    fetchNotificaciones();
  };

  const fetchCertificadosNuevos = async () => {
    try {
      const response = await fetch(
        `https://oficinavirtual-solponiente.com/api/solicitudes/usuarios/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        const nuevos = data.filter(
          (s) => s.TipoSolicitud === "certificado" && !s.VistoUsuario
        ).length;
        setCertificadosNuevos(nuevos);
      } else {
        // 404 = el usuario aún no tiene ninguna solicitud, no es un error real
        setCertificadosNuevos(0);
      }
    } catch (error) {
      console.error("Error al obtener certificados:", error);
    }
  };

  const navigate = (section) => {
    setActiveSection(section);
    if (section === "certificados" && certificadosNuevos > 0) {
      fetch("https://oficinavirtual-solponiente.com/api/solicitudes/certificados/marcar-vistos", {
        method: "PUT",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
        .then(() => setCertificadosNuevos(0))
        .catch((e) => console.error("Error al marcar certificados como vistos:", e));
    }
  };

  const renderContent = () => {
    switch (activeSection) {
      case "home":
        return (
          <div className="d-flex flex-column">
            <Header />
            <main className="flex-grow-1">
            <Row className="p-3">
            <Col md={6}>
              <Card className="mb-4 shadow-sm dashboard-card">
                <Card.Img variant="top" src={registro} alt="Buzón de Registro" />
                <Card.Body>
                  <Card.Title>
                    <i className="bi bi-pencil-square"></i> <strong>Registro</strong>
                  </Card.Title>
                  <Card.Text>
                    Acceda al registro. Pulse en el botón para acceder al buzón
                    de registro.
                  </Card.Text>
                  <Button
                    variant="primary"
                    onClick={() => navigate("registro")}
                  >
                    Registro
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="mb-4 shadow-sm dashboard-card">
                <Card.Img variant="top" src={documentosjpg} alt="Documentos" />
                <Card.Body>
                  <Card.Title>
                    <i className="bi bi-file-earmark-text"></i>{" "}
                    <strong>Documentos</strong>
                  </Card.Title>
                  <Card.Text>
                    Compruebe sus documentos presentados.
                  </Card.Text>
                  <Button
                    variant="primary"
                    onClick={() => navigate("documentos")}
                  >
                    Documentos
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="mb-4 shadow-sm dashboard-card">
                <Card.Img
                  variant="top"
                  src={notificacionesjpg}
                  alt="Notificaciones"
                />
                <Card.Body>
                  <Card.Title>
                    <i className="bi bi-bell"></i>{" "}
                    <strong>Notificaciones</strong>
                    {notificacionesNoLeidas > 0 && (
                      <span className="badge bg-danger rounded-pill ms-2">
                        {notificacionesNoLeidas}
                      </span>
                    )}
                  </Card.Title>
                  <Card.Text>
                    Compruebe sus notificaciones recibidas.
                  </Card.Text>
                  <Button
                    variant="primary"
                    onClick={() => navigate("notificaciones")}
                  >
                    Notificaciones
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="mb-4 shadow-sm dashboard-card">
                <Card.Img variant="top" src={solicitudesjpg} alt="Solicitudes" />
                <Card.Body>
                  <Card.Title>
                    <i className="bi bi-file-text"></i>{" "}
                    <strong>Solicitudes</strong>
                  </Card.Title>
                  <Card.Text>
                    Compruebe sus solicitudes presentadas.
                  </Card.Text>
                  <Button
                    variant="primary"
                    onClick={() => navigate("solicitudes")}
                  >
                    Solicitudes
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="mb-4 shadow-sm dashboard-card">
                <div className="dashboard-card-banner">
                  <i className="bi bi-folder2-open"></i>
                </div>
                <Card.Body>
                  <Card.Title>
                    <i className="bi bi-folder2-open"></i>{" "}
                    <strong>Expedientes</strong>
                  </Card.Title>
                  <Card.Text>
                    Consulte el estado de sus expedientes y verifique documentos por CSV.
                  </Card.Text>
                  <Button
                    variant="primary"
                    onClick={() => navigate("expedientes")}
                  >
                    Expedientes
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="mb-4 shadow-sm dashboard-card">
                <div className="dashboard-card-banner">
                  <i className="bi bi-patch-check"></i>
                </div>
                <Card.Body>
                  <Card.Title>
                    <i className="bi bi-patch-check"></i>{" "}
                    <strong>Certificados</strong>
                    {certificadosNuevos > 0 && (
                      <span className="badge bg-danger rounded-pill ms-2">
                        {certificadosNuevos}
                      </span>
                    )}
                  </Card.Title>
                  <Card.Text>
                    Solicite certificados y descargue los que ya estén firmados por la administración.
                  </Card.Text>
                  <Button
                    variant="primary"
                    onClick={() => navigate("certificados")}
                  >
                    Certificados
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            </Row>
            </main>
          </div>
        );
      case "registro":
        return <BuzonRegistro />;
      case "documentos":
        return <DocumentosPresentados />;
      case "notificaciones":
        return (
          <NotificacionesUsuario
            onActualizarLeidas={actualizarContadorNoLeidas}
          />
        );
      case "solicitudes":
        return <SolicitudesUsuario />;
      case "expedientes":
        return <ExpedientesUsuario />;
      case "certificados":
        return <MisCertificados />;
      case "publicaciones":
        return <PublicacionesUsuario />;
      default:
        return <h3>Inicio</h3>;
    }
  };

  const navLinks = [
    { key: "home", icon: "bi-house", label: "Inicio" },
    { key: "registro", icon: "bi-pencil-square", label: "Buzón de Registro" },
    { key: "certificados", icon: "bi-patch-check", label: "Certificados", badge: certificadosNuevos },
    { key: "notificaciones", icon: "bi-bell", label: "Notificaciones", badge: notificacionesNoLeidas },
    { key: "solicitudes", icon: "bi-file-text", label: "Solicitudes" },
    { key: "expedientes", icon: "bi-folder2-open", label: "Expedientes" },
    { key: "documentos", icon: "bi-file-earmark-text", label: "Documentos" },
    { key: "publicaciones", icon: "bi-megaphone", label: "Publicaciones" },
  ];

  return (
    <Container fluid>
      <Row className="min-vh-100">
        {/* Sidebar desktop */}
        <Col xs={12} md={3} lg={2} className="sidebar bg-light p-0">
          <Navbar className="flex-column d-none d-md-flex p-0">
            <Navbar.Brand className="sidebar-brand">
              <img src={logo} alt="Logo Solponiente" />
            </Navbar.Brand>
            <Nav className="flex-column w-100 px-3 pb-3">
              {navLinks.map((link) => (
                <Nav.Link
                  key={link.key}
                  className={`d-flex justify-content-between align-items-center ${
                    activeSection === link.key ? "active" : ""
                  }`}
                  onClick={() => navigate(link.key)}
                >
                  <div>
                    <i className={`bi ${link.icon} me-2`}></i>
                    {link.label}
                  </div>
                  {link.badge > 0 && (
                    <span className="badge bg-danger rounded-pill">
                      {link.badge}
                    </span>
                  )}
                </Nav.Link>
              ))}
              <Nav.Link
                className="text-danger"
                onClick={() => {
                  localStorage.removeItem("token");
                  window.location.href = "/login";
                }}
              >
                <i className="bi bi-box-arrow-right me-2"></i> Cerrar Sesión
              </Nav.Link>
            </Nav>
          </Navbar>

          {/* Menú móvil (Accordion) */}
          <Col className="text-primary mt-4 mb-2 text-center d-md-none">
            <h5>Oficina Virtual Solponiente</h5>
          </Col>
          <Accordion className="d-block d-md-none mb-3 mx-3">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <strong className="text-primary">Menú</strong>
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column">
                  {navLinks.map((link) => (
                    <Nav.Link
                      key={link.key}
                      className={`d-flex justify-content-between align-items-center ${
                        activeSection === link.key ? "active" : ""
                      }`}
                      onClick={() => navigate(link.key)}
                    >
                      <div>
                        <i className={`bi ${link.icon} me-2`}></i>
                        {link.label}
                      </div>
                      {link.badge > 0 && (
                        <span className="badge bg-danger rounded-pill">
                          {link.badge}
                        </span>
                      )}
                    </Nav.Link>
                  ))}
                  <Nav.Link
                    className="text-danger"
                    onClick={() => {
                      localStorage.removeItem("token");
                      window.location.href = "/login";
                    }}
                  >
                    <i className="bi bi-box-arrow-right me-2"></i> Cerrar Sesión
                  </Nav.Link>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        {/* Contenido principal */}
        <Col xs={12} md={9} lg={10}>
          {renderContent()}
        </Col>

        <Footer />
      </Row>
    </Container>
  );
};

export default Home;
